import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';

const AuthDebug = () => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [showDebug, setShowDebug] = useState(false);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    
    setToken(storedToken);
    try {
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (e) {
      console.error('Error parsing user:', e);
    }
  }, []);

  const handleClearStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  if (!showDebug) {
    return (
      <Button 
        variant="link" 
        size="sm" 
        className="text-muted" 
        onClick={() => setShowDebug(true)}
      >
        Debug Auth
      </Button>
    );
  }

  return (
    <Card className="mb-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>Auth Debug Info</span>
        <Button 
          variant="link" 
          size="sm" 
          className="text-muted" 
          onClick={() => setShowDebug(false)}
        >
          Hide
        </Button>
      </Card.Header>
      <Card.Body>
        <h6>Token:</h6>
        <pre className="border p-2 bg-light" style={{ maxHeight: '100px', overflow: 'auto' }}>
          {token || 'No token found'}
        </pre>
        
        <h6 className="mt-3">User:</h6>
        <pre className="border p-2 bg-light" style={{ maxHeight: '100px', overflow: 'auto' }}>
          {user ? JSON.stringify(user, null, 2) : 'No user found'}
        </pre>
        
        <Button 
          variant="danger" 
          size="sm" 
          className="mt-3"
          onClick={handleClearStorage}
        >
          Clear Storage & Logout
        </Button>
      </Card.Body>
    </Card>
  );
};

export default AuthDebug;
